<template>
  <div class="head">
    <img
      class="head-back"
      src="../assets/menuback.png"
    >
    <img
      class="logo-head btn"
      src="../assets/LOGO.png"
      title="home"
      @click="homeHandler"
    >
    <div class="menu">
      <div
        class="menu-btn mouse-hover"
        @click="navLink('https://lin.ee/qDw4ZTC')"
      >
        <img
          class="btn-normal"
          src="../assets/1-2.png"
          alt=""
          srcset=""
        >
        <img
          class="btn-hover"
          src="../assets/1-1.png"
          alt=""
          srcset=""
        >
      </div>
      <div
        class="menu-btn mouse-hover"
        @click="navLink('https://t.me/Web3PlantsZombiesBot')"
      >
        <img
          class="btn-normal"
          src="../assets/2-2.png"
          alt=""
          srcset=""
        >
        <img
          class="btn-hover"
          src="../assets/2-1.png"
          alt=""
          srcset=""
        >
      </div>
      <div
        class="
            menu-btn mouse-hover"
        @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper')"
      >
        <img
          class="btn-normal"
          src="../assets/3-2.png"
          alt=""
          srcset=""
        >
        <img
          class="btn-hover"
          src="../assets/3-1.png"
          alt=""
          srcset=""
        >
      </div>
      <div
        class="menu-btn mouse-hover"
        @click="navLink('http://staking.web3pvz.com/')"
      >

        <img
          class="btn-hover disabled-btn"
          src="../assets/7-1.png"
          alt=""
          srcset=""
        >
        <img
          class="btn-normal disabled-btn"
          src="../assets/7-2.png"
          alt=""
          srcset=""
        >
      </div>
      <!-- <img
            class="disabled-btn"
            src="../assets/8-2.png"
            alt=""
            srcset=""
          > -->
      <div
        class="menu-btn mouse-hover"
        @click="changeIndex(1)"
      >
        <img
          class="btn-normal"
          src="../assets/8-2.png"
          alt=""
          srcset=""
        >
        <img
          class="btn-hover"
          src="../assets/8-1.png"
          alt=""
          srcset=""
        >
      </div>
      <div
        class="menu-btn mouse-hover"
        @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/telgather-team')"
      >
        <img
          class="btn-normal"
          src="../assets/6-2.png"
          alt=""
          srcset=""
        >
        <img
          class="btn-hover"
          src="../assets/6-1.png"
          alt=""
          srcset=""
        >
      </div>
      <div
        class="menu-btn mouse-hover"
        @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/road-to-launch')"
      ><img
          class="btn-normal"
          src="../assets/5-2.png"
          alt=""
          srcset=""
        ><img
          class="btn-hover"
          src="../assets/5-1.png"
          alt=""
          srcset=""
        ></div>
    </div>
    <div class="hamburger-menu">
      <input
        id="menu__toggle"
        type="checkbox"
      />
      <label
        class="menu__btn"
        for="menu__toggle"
      >
        <span></span>
      </label>
      <ul class="menu__box">
        <li><a
            class="menu__item"
            @click="navLink('https://lin.ee/qDw4ZTC')"
          >Telegram</a></li>
        <li><a
            class="menu__item"
            @click="navLink('https://t.me/Web3PlantsZombiesBot')"
          >Line</a></li>
        <li><a
            class="menu__item"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper')"
          >Deadpaper</a></li>
        <li><a
            class="menu__item"
            @click="navLink('http://staking.web3pvz.com/')"
          >Staking</a></li>
        <li><a
            class="menu__item"
            @click="changeIndex(1)"
          >Claim Token</a></li>
        <li><a
            class="menu__item"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/telgather-team')"
          >Team</a></li>
        <li><a
            class="menu__item"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/road-to-launch')"
          >Roadmap</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuHome',
  methods: {
    navLink (url) {
      window.open(url, '_blank')
    },
    homeHandler () {
      this.$router.push("/")
    },
    changeIndex (index) {
      switch (index) {
        case 0:
          this.$router.push("/")
          break;
        case 1:
          this.$router.push("/ClaimToken")
          break;
        case 2:
          this.$router.push("/publicsale")
          break;
      }
      // this.$emit('changeIndex', index)
    }
  }
}
</script>
<style lang="scss" scoped>
.head {
  position: absolute;
  max-width:1200px;
  width: 75vw;
  height: 9vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  .logo-head {
    width: 7.8rem;
    position: absolute;
    left: 2.5%;
    top: 25px;
    z-index: 3;
    cursor: pointer;
  }

  .head-back {
    height: 11vh;
    width: 75vw;
    max-width:1200px;
    @media (max-width: 1500px) {
      display: none;
    }
  }

  .mouse-hover {
    cursor: pointer;
  }
  .btn-normal {
    display: block;
    width: 9vw;
    height: 4.5vh;
    max-width:142px;
    // width: 96%;
    // height:80%;
  }
  .btn-hover {
    display: none;
    width: 9vw;
    max-width:142px;
    height: 4.5vh;
    // width: 96%;
    // height: 80%;
  }
  .menu-btn {
    &:hover {
      .btn-hover {
        display: block;
      }
      .btn-normal {
        display: none;
      }
    }
  }

  .menu {
    position: absolute;
    top: 4.5vh;
    left: 9vw;
    display: flex;
    justify-content: flex-start;
    @media (max-width: 1500px) {
      display: none;
    }
  }

  .hamburger-menu {
    position: relative;
    top: 50px;
    right: 200px;
    display: none;
    z-index: 10; /* Ensure it's on top */

    @media (max-width: 1500px) {
      display: block;
    }
  }

  #menu__toggle {
    opacity: 0;
  }

  #menu__toggle:checked + .menu__btn > span {
    transform: rotate(45deg);
  }

  #menu__toggle:checked + .menu__btn > span::before {
    top: 0;
    transform: rotate(0deg);
  }

  #menu__toggle:checked + .menu__btn > span::after {
    top: 0;
    transform: rotate(90deg);
  }

  #menu__toggle:checked ~ .menu__box {
    display: block;
  }

  .menu__btn {
    position: fixed;
    top: 6vh;
    right: 10vw;
    width: 26px;
    height: 26px;
    cursor: pointer;
    z-index: 1;

    @media (max-width: 768px) {
      top: 8vh;
    }
  }

  .menu__btn > span,
  .menu__btn > span::before,
  .menu__btn > span::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #ffffff;
    transition-duration: 0.25s;
  }

  .menu__btn > span::before {
    content: '';
    top: -8px;
  }

  .menu__btn > span::after {
    content: '';
    top: 8px;
  }

  .menu__box {
    display: none;
    position: fixed;
    height: fit-content;
    top: 120px;
    left: 50%;
    transform: translateX(-50%) scale(1.25);
    width: 500px;
    margin: 0;
    padding: 60px 40px 40px 40px;
    list-style: none;
    background: url(../assets/mobilemenubg.png) no-repeat center center;
    background-size: contain;
    transition-duration: 0.25s;
  }

  .menu__item {
    display: block;
    padding: 0px 24px;
    color: #fff;
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 24px;
    font-weight: 600;
    text-decoration: none;
    transition-duration: 0.25s;
  }

  .menu__item:hover {
    background-color: #cfd8dc;
  }
}
</style>